import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchComplianceFrameworks, patchComplianceControl, createComplianceFramework, createComplianceControl } from '../../services/api/complianceService';

export const loadCompliance = createAsyncThunk('compliance/load', async () => fetchComplianceFrameworks());
export const addFramework = createAsyncThunk('compliance/addFramework', async (payload) => createComplianceFramework(payload));
export const addControl = createAsyncThunk('compliance/addControl', async ({ frameworkId, payload }) => ({ frameworkId, control: await createComplianceControl(frameworkId, payload) }));
export const updateControl = createAsyncThunk('compliance/updateControl', async ({ id, changes }) => patchComplianceControl(id, changes));

const mutationPending = (state) => { state.mutationStatus = 'loading'; state.error = null; };
const mutationRejected = (state, action) => { state.mutationStatus = 'failed'; state.error = action.error?.message || 'The compliance change could not be saved.'; };

const complianceSlice = createSlice({
  name: 'compliance',
  initialState: { status: 'idle', mutationStatus: 'idle', error: null, frameworks: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadCompliance.pending, (state) => { state.status = 'loading'; state.error = null; })
      .addCase(loadCompliance.fulfilled, (state, action) => { state.status = 'succeeded'; state.frameworks = action.payload; })
      .addCase(loadCompliance.rejected, (state, action) => { state.status = 'failed'; state.error = action.error?.message || 'Compliance data could not be loaded.'; })
      .addCase(addFramework.pending, mutationPending)
      .addCase(addFramework.fulfilled, (state, action) => { state.mutationStatus = 'succeeded'; state.frameworks.unshift(action.payload); })
      .addCase(addFramework.rejected, mutationRejected)
      .addCase(addControl.pending, mutationPending)
      .addCase(addControl.fulfilled, (state, action) => { state.mutationStatus = 'succeeded'; const fw = state.frameworks.find((f) => f.id === action.payload.frameworkId); if (fw) fw.controls.push(action.payload.control); })
      .addCase(addControl.rejected, mutationRejected)
      .addCase(updateControl.pending, mutationPending)
      .addCase(updateControl.fulfilled, (state, action) => { state.mutationStatus = 'succeeded'; for (const fw of state.frameworks) { const control = fw.controls.find((c) => c.id === action.payload.id); if (control) Object.assign(control, action.payload); } })
      .addCase(updateControl.rejected, mutationRejected);
  }
});

export default complianceSlice.reducer;
